import { PerformancePersonalReviewStatusEnum } from 'app/library/performance-personal-review/enums/performance-personal-review-status.enum';
import { SimpleEntity } from 'app/projects/shared/src/lib/models/simple-entity.model';
import { IToDoReviewQuery } from '../interfaces/todo-review.query.interface';

export class ToDoPerformanceReview {
    id: number;
    status: string;
    isViewedByOwner: boolean;
    team: SimpleEntity;
    name: string;
    startDate: Date;
    dueDate: Date;
    type: SimpleEntity;
    periodUnderReviewId: number;
    goalSettingPeriodId: number;

    constructor(query: IToDoReviewQuery) {
        this.id = query.id;
        this.status = query.status;
        this.isViewedByOwner = query.is_viewed_by_owner;
        this.team = query.team ? new SimpleEntity(query.team) : null;
        this.name = query.name;
        this.startDate = new Date(query.start_date);
        this.dueDate = new Date(query.due_date);
        this.type = query.type ? new SimpleEntity(query.type) : null;
        this.periodUnderReviewId = query.period_under_review.id;
        this.goalSettingPeriodId = query.goal_setting_period.id;
    }

    get isOverdue(): boolean {
        return new Date() > this.dueDate && this.status !== PerformancePersonalReviewStatusEnum.COMPLETED && this.status !== PerformancePersonalReviewStatusEnum.CANCELED;
    }
}
